<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="REPORTE" key="1">
          <g-master name="evaluaciones"
                    :endpoint="evaluationMaster.endpoint"
                    :tableSetup="evaluationMaster.tableSetup"
                    :modalFieldsSetup="evaluationMaster.modalFieldsSetup"
                    modalWidth="90%"
                    @action="masterAction"
                    :beforeSend="beforeSend"
                    :parentData="filterParams"
                    ref="master"
          >
            <template slot="customButton">
              <a-select placeholder="Filtro Por Estado" style="width: 200px" v-model="filterStatus" v-bind="selOptions">
                <a-select-option v-for="opcion in estados" :key="opcion.value">
                  {{ opcion.name }}
                </a-select-option>
              </a-select>
              <a-button type="primary" @click="filtrar">Filtrar</a-button>
            </template>

            <template slot="customButton">
              <a-tooltip placement="top">
                <template slot="title">
                  Descargar Reporte
                </template>
                <a-button style="margin-left: 10px" shape="circle" icon="download"
                          @click="importReportJson"/>
              </a-tooltip>
            </template>

            <template slot="customButton">
              <a-tooltip>
                <template slot="title">
                  Subir Reporte
                </template>
                <a-upload
                  name="json_file"
                  :before-upload="beforeUpload"
                  :fileList="jsonFile"
                  :remove="() => { jsonFile = [] }">
                  <a-button shape="circle" icon="upload" type="upload"/>
                </a-upload>
              </a-tooltip>
            </template>

            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Nombre">
                    <a-input
                      v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Descripción">
                    <a-input
                      v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Roles')"
                              :selectConfig="{mode:'multiple'}"
                              :formItemConfig="fiOptions"
                              endpoint="role"
                              :decorator="['role_name', { rules: [{ required: false, message: 'Valor requerido' }] }]">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Id emp">
                    <a-input
                      v-decorator="['id_emp_column', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              label="Tipo de salida"
                              :formItemConfig="fiOptions"
                              :decorator="['id_h_output_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :selectedObj.sync="outputTypeSelected"
                              :params="id_h_output_type"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              label="Tipo de gráfica"
                              :formItemConfig="fiOptions"
                              :decorator="['tipo_grafica', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                              :params="tipo_grafica"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-show="isDelimiterRequired" v-bind="fiOptions" label="Delimitador">
                    <a-input
                      v-decorator="['delimiter', { rules: [{ required: isDelimiterRequired, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Activo" :has-feedback="false">
                    <a-checkbox v-decorator="['active', {valuePropName: 'checked'}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              label="Tipo de reporte"
                              :formItemConfig="fiOptions"
                              :selectedObj.sync="tipoReporteSeleccionado"
                              :decorator="['tipo_reporte', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                              :params="tipo_reporte"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Subconsulta')" v-bind="fiOptions">
                    <a-textarea autoSize
                                v-decorator="['subquery', { rules: [{ required: requiredSubquery, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Vista">
                    <a-input
                      v-decorator="['view', { rules: [{ required: requiredView, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="Columnas" key="1">
              <greportcol v-if="idGreport" :id_g_report="idGreport"></greportcol>
              <span v-else>Seleccione una evaluación para ver más.</span>
            </a-tab-pane>
            <a-tab-pane tab="Parámetros" key="2">
              <reportparams v-if="idGreport" :id_g_report="idGreport"></reportparams>
              <span v-else>Seleccione una evaluación para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </a-tab-pane>
      </a-tabs>
    </a-row>

    <a-row>
    </a-row>
  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        selOptions: {
          allowClear: true
        },
        filterStatus: 1,
        filterParams: {
          active_desc: 1
        },
        estados: [
          {name: 'ACTIVOS', value: 1},
          {name: 'INACTIVOS', value: 0},
          {name: 'TODOS', value: null}
        ],
        tipoReporteSeleccionado: {},
        requiredSubquery: false,
        requiredView: false,
        isDelimiterRequired: false,
        id_h_output_type: {
          h_lookup_type: 'G_REPORT_OUTPUT_TYPE'
        },
        tipo_grafica: {
          h_lookup_type: 'REPORTE_TIPO_GRAFICA',
          use_equivalency: true
        },
        tipo_reporte: {
          h_lookup_type: 'REPORTE_TIPO_REPORTE',
          use_equivalency: true
        },
        visible: false,
        colOptions: {xs: 24, sm: 12},
        colSpan: {xs: 24, md: 6},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        evaluationMaster: {
          actions: {
            actions: [
              {
                name: 'masterEdit',
                text: 'Editar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'edit'}
              },
              {
                name: 'masterDelete',
                text: 'Eliminar',
                permisos: [],
                props: {size: 'small', icon: 'delete', type: 'link'}
              }
            ]
          },
          endpoint: 'greports',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Delimitador', dataIndex: 'delimiter', sorter: true},
              {title: 'Tipo de salida', dataIndex: 'h_output_type', sorter: true},
              {title: 'Empleado', dataIndex: 'id_emp_column', sorter: true},
              {title: 'Rol', dataIndex: 'role_name', sorter: true},
              {title: 'Vista', dataIndex: 'view', sorter: true},
              {title: 'Estado', dataIndex: 'active_desc', sorter: true},
              {title: 'Tipo de gráfica', dataIndex: 'tipo_grafica', sorter: true},
              {title: 'Tipo de reporte', dataIndex: 'tipo_reporte', sorter: true},
              {title: 'Subconsulta', dataIndex: 'subquery', sorter: true}
            ],
            allowSelect: true,
            selectedRows: []
          },
          modalFieldsSetup: [
            {name: 'name'},
            {name: 'description'},
            {name: 'view'},
            {name: 'role_name'},
            {name: 'h_output_type'},
            {name: 'id_emp_column'},
            {name: 'id_h_output_type'},
            {name: 'delimiter'},
            {name: 'active', type: 'boolean'},
            {name: 'tipo_grafica'},
            {name: 'subquery'},
            {name: 'tipo_reporte'}
          ]
        },
        outputTypeSelected: {},
        loading: false,
        jsonFile: [],
        statusFile: true
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.httpClientUploader = this.httpClient.getNewInstance()
      this.httpClientUploader.defaults.headers['Content-Type'] = 'multipart/form-data'
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.isDelimiterRequired = action.record.h_output_type !== 'XLSX'
            this.$refs.master && this.$refs.master.modal.form.setFieldsValue({
              role_name: this.$isEmpty(action.record.role_name) ? [] : action.record.role_name.split(',')
            })
            break
        }
      },
      beforeSend (data) {
        if (!this.$isEmpty(data.role_name)) {
          data.role_name = data.role_name.join(',')
        } else {
          data.role_name = ''
        }
        return data
      },
      filtrar () {
        this.filterParams = {active_desc: this.filterStatus}
      },
      beforeUpload (file) {
        if (this.validateFile(file)) {
          this.jsonFile = [file]
          this.exportReportJson()
        }
        return false
      },
      validateFile (file) {
        const array = ['text/plain']
        const isJpgOrPng = file.type
        if (!array.includes(isJpgOrPng)) {
          this.$message.error('Solo se pemiten documentos de texto plano (.txt)')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      },
      importReportJson () {
        this.httpClient.getInstance().post('greports/import/' + this.evaluationMaster.tableSetup.selectedRows[0].id, {responseType: 'arraybuffer'})
          .then((response) => {
            let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
            fileURL = window.URL.createObjectURL(fileURL)
            let fileLink = document.getElementById('file_link_elm')
            if (fileLink === null) {
              fileLink = document.createElement('a')
              fileLink.setAttribute('id', 'file_link_elm')
              document.body.appendChild(fileLink)
            }
            fileLink.setAttribute('href', fileURL)
            fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
            fileLink.click()
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible descargar el archivo.')
          })
      },
      exportReportJson () {
        if (this.jsonFile.length > 0) {
          let request = new FormData()
          this.loading = true
          request.append('document', this.jsonFile[0])
          this.httpClientUploader.post('greports/export', request)
            .then((response) => {
              Mensajes.success(response.data.message)
            })
            .catch((error) => {
              Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible realizar el cargue'))
            })
            .then(() => {
              this.loading = false
            })
        } else {
          Mensajes.error('Error', 'Debes de cargar un archivo.')
        }
      }
    },
    watch: {
      tipoReporteSeleccionado () {
        if (this.tipoReporteSeleccionado.equivalency === 'subquery') {
          this.requiredSubquery = true
        } else {
          this.requiredSubquery = false
        }
        if (this.tipoReporteSeleccionado.equivalency === 'view') {
          this.requiredView = true
        } else {
          this.requiredView = false
        }
      },

      outputTypeSelected () {
        if (this.outputTypeSelected.text === 'XLSX') {
          this.isDelimiterRequired = false
        } else {
          this.isDelimiterRequired = true
        }
      }
    },
    computed: {
      idGreport () {
        return this.evaluationMaster.tableSetup.selectedRows.length > 0 ? this.evaluationMaster.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Greport/Report.vue